import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
// import SplitType from 'split-type';
import ScrollReveal from 'scrollreveal';

gsap.registerPlugin(ScrollTrigger);

const AppScripts = () => {
    const location = useLocation();

    useEffect(() => {
        // SMOOTH SCROLL WITH LENIS
        const lenis = new Lenis();
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        return () => {
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        // ABOUT US JS - ScrollReveal
        try {
            ScrollReveal({ reset: true });
            ScrollReveal().reveal(".slide-up2", {
                duration: 2000,
                origin: "bottom",
                distance: "100px",
                easing: "cubic-bezier(.37,.01,.74,1)",
            });
        } catch (e) {
            console.warn("ScrollReveal error:", e);
        }

        // BOOK PAGE - TEXT ANIMATION
        // const splitTypes = document.querySelectorAll('.reveal-type');
        // splitTypes.forEach((char) => {
        //     const bg = char.dataset.bgColor;
        //     const fg = char.dataset.fgColor;
        //     const text = new SplitType(char, { types: 'chars' });

        //     gsap.fromTo(text.chars,
        //         {
        //             color: bg,
        //         },
        //         {
        //             color: fg,
        //             duration: 0.3,
        //             stagger: 0.02,
        //             scrollTrigger: {
        //                 trigger: char,
        //                 start: 'top 80%',
        //                 end: 'top 20%',
        //                 scrub: true,
        //                 markers: false,
        //                 toggleActions: 'play play reverse reverse'
        //             }
        //         }
        //     );
        // });

        // Refresh ScrollTrigger after DOM updates
        ScrollTrigger.refresh();

    }, [location.pathname]);

    return null;
};

export default AppScripts;
